import type { IconSvgObject } from './types';

const ArrowDownZaIcon: IconSvgObject = [
  ["path", { d: "M3.75 16L7.75 20L11.75 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.75 19V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.25 18H19.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20.25 20L18.4081 14.4743C18.3137 14.1911 18.0486 14 17.75 14C17.4514 14 17.1863 14.1911 17.0919 14.4743L15.25 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M15.75 4H19.75L15.75 10H19.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default ArrowDownZaIcon;
